import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-take-course-drawer',
  templateUrl: './take-course-drawer.component.html',
  styleUrls: ['./take-course-drawer.component.scss']
})
export class TakeCourseDrawerComponent implements OnInit {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  get completedCount(): number {
    return (this.challenge.coursesInfo || []).filter((c: any) => c.completedStatus).length;
  }

  close() {
    this.closed.emit();
  }

  previewDoc: any = null;

  viewDoc(doc: any) {
    this.previewDoc = doc;
  }

  closePreview() {
    this.previewDoc = null;
  }

  downloadDoc(doc: any) {
    if (doc.url || doc.link) {
      const a = document.createElement('a');
      a.href = doc.url || doc.link;
      a.download = doc.name || 'document';
      a.click();
    }
  }

  downloadAll() {
    (this.challenge.documents || []).forEach((doc: any) => this.downloadDoc(doc));
  }

  constructor(private sanitizer: DomSanitizer) { }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    console.log('takeCourse',this.challenge)
  }
  setTime(date: any): Date {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: string): string {
    const month = Number(date.substring(5, 7).replace(/^0+/, ''));
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month - 1]} ${day}, ${year}`;
  }

  getStatus(check: any, completedBy: string, creationDate: string, startDate: string): string {
    const lang = localStorage.getItem('selectedLanguage');
    let value = '';

    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) {
        value = '닫은';
      }
      if (creationOn && pending) {
        value = '대기 중';
      }
      if (check) {
        value = '';
      }
    }
    else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) {
        value = '閉まっている';
      }
      if (creationOn && pending) {
        value = '保留中';
      }
      if (check) {
        value = '';
      }
    }
    else {
      value = 'Open';
      if (!check && isExpired) {
        value = 'Closed';
      }
      if (creationOn && pending) {
        value = 'Pending';
      }
      if (check) {
        value = '';
      }
    }

    return value;
  }
}
